import { Flex, Button, Image, Text } from "@chakra-ui/react";
import { PlayIcon } from "../../components/icons/PlayIcon";
import {
  useIsSmallBreakpoint,
  useMobileBreakpoint,
} from "../../utils/useBreakpoints";
import { HeroMaskIcon } from "../../components/icons/valkyrae/HeroMaskIcon";
import { useUserData } from "../../hooks/useUserData";

export function Hero({
  heroRef,
  handleCta,
  handleCta2,
}: {
  heroRef?: React.RefObject<HTMLDivElement>;
  handleCta?: () => void;
  handleCta2?: () => void;
}) {
  const isMobileBreakpoint = useMobileBreakpoint();

  if (isMobileBreakpoint) {
    return (
      <Flex
        ref={heroRef}
        maxWidth="100%"
        width="fit-content"
        position="relative"
        overflow="hidden"
        justifyContent="center"
      >
        <Flex
          width="100%"
          maxWidth="1440px"
          position="relative"
          minHeight="400px"
          style={{
            maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
            maskSize: "cover",
            maskPosition: "80% -70px",
            maskRepeat: "no-repeat",
            backgroundImage: `linear-gradient(180deg, #d9d9d945 100%)`,
            backgroundSize: "contain",
            backgroundPosition: "center calc(100% - 10px)",
            backgroundRepeat: "no-repeat",
            backgroundBlendMode: "difference",
          }}
        >
          <Flex
            width="100%"
            height="fit-content"
            minHeight="450px"
            marginBottom="10px"
            style={{
              maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
              maskSize: "cover",
              maskPosition: "calc(80% - 10px) -70px",
              maskRepeat: "no-repeat",
              backgroundImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_apollyon_image_v2.png), linear-gradient(180deg, #4283DB, #DEECFF) `,
              backgroundSize: "cover",
              backgroundPosition: "center -70px",
              backgroundRepeat: "no-repeat",
              backgroundBlendMode: "overlay",
            }}
            flexDirection="column"
          >
            <HeroContext handleCta={handleCta} handleCta2={handleCta2} />
            <Image
              src={`${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_rae_test_v2.png`}
              alt="Valkyrae"
              width="100%"
              opacity="1"
              zIndex={2}
              loading="eager"
              decoding="sync"
            />
          </Flex>
        </Flex>
        <Flex position="absolute" bottom="46px" left="-4%" width="104%">
          <svg
            width="100%"
            height="auto"
            viewBox="0 0 1439 724"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M1367 0H287H72.7483C31.5498 0 -1.2481 34.5053 0.840933 75.6507L25.2119 555.661C27.0155 591.184 54.489 620.067 89.8778 623.645L1072.29 722.955C1097.15 725.469 1121.54 714.907 1136.72 695.052L1424.2 319.067C1433.8 306.51 1439 291.142 1439 275.335V72C1439 32.2355 1406.76 0 1367 0Z"
              fill="transparent"
              stroke="rgba(255, 255, 255, 0.16)"
              strokeWidth="1px"
            />
          </svg>
        </Flex>
      </Flex>
    );
  }
  return (
    <Flex
      ref={heroRef}
      width="1440px"
      position="relative"
      pr="32px"
      minHeight="700px"
      style={{
        maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
        maskSize: "cover",
        maskPosition: "0% -70px",
        maskRepeat: "no-repeat",
      }}
    >
      <HeroMaskIcon
        position="absolute"
        top="-70px"
        left="0"
        width="100%"
        height="100%"
        color="transparent"
        strokeWidth="1px"
        stroke="rgba(255, 255, 255, 0.16)"
      />
      <Flex
        width="fit-content"
        maxWidth="100%"
        position="relative"
        px="10px"
        marginBottom="32px"
        style={{
          maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
          maskSize: "cover",
          maskPosition: "0% -70px",
          maskRepeat: "no-repeat",
          backgroundImage: `linear-gradient(180deg, rgba(255, 255, 255, 0.16) 100%)`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundBlendMode: "difference",
        }}
      >
        <Flex
          position="relative"
          width="100%"
          maxWidth="1440px"
          height="fit-content"
          minHeight="600px"
          style={{
            maskImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_mask_v2.svg)`,
            maskSize: "cover",
            maskPosition: "0% -75px",
            maskRepeat: "no-repeat",
            backgroundImage: `url(${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_apollyon_image_v2.png),  linear-gradient(180deg, #4283DB, #DEECFF)`,
            backgroundSize: "cover",
            backgroundPosition: "0% -70px",
            backgroundRepeat: "no-repeat",
            backgroundBlendMode: "screen",
          }}
          flexDirection="column"
        >
          <Image
            src={`${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_apollyon_image_v2.png`}
            alt="Valkyrae"
            width="100%"
            height="fit-content"
            opacity="0"
            zIndex={1}
            loading="eager"
            decoding="sync"
          />

          <Image
            position="absolute"
            src={`${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_texture_v2.svg`}
            alt="Valkyrae"
            width="auto"
            height="100%"
            top="-30%"
            left="-5%"
            opacity="1"
            zIndex={1}
            loading="eager"
            decoding="sync"
          />
          <Image
            position="absolute"
            src={`${window.gc.global.assets_url}/static/images/web-ui/valkyrae/hero_rae_test_v2.png`}
            alt="Valkyrae"
            width="auto"
            height="100%"
            opacity="1"
            zIndex={2}
            loading="eager"
            decoding="sync"
          />
          <HeroContext handleCta={handleCta} handleCta2={handleCta2} />
        </Flex>
      </Flex>
    </Flex>
  );
}
export function HeroContext({
  handleCta,
  handleCta2,
}: {
  handleCta?: () => void;
  handleCta2?: () => void;
}) {
  const { userData } = useUserData();
  const isSmallBreakpoint = useIsSmallBreakpoint();
  const isMobileBreakpoint = useMobileBreakpoint();

  const isUserGold = userData?.gold;
  return (
    <Flex
      zIndex={3}
      position={isMobileBreakpoint ? "relative" : "absolute"}
      maxWidth={
        isMobileBreakpoint ? "100vw" : isSmallBreakpoint ? "350px" : "450px"
      }
      width={isMobileBreakpoint ? "400px" : "fit-content"}
      margin={
        isMobileBreakpoint
          ? "0% auto"
          : isSmallBreakpoint
            ? "5% auto auto 55%"
            : "3% auto auto 56%"
      }
      justifyContent={isMobileBreakpoint ? "flex-start" : "center"}
      flexDirection="column"
      pt={isMobileBreakpoint ? "60px" : undefined}
      pr={isMobileBreakpoint ? undefined : "0px"}
    >
      <Image
        alignSelf={isMobileBreakpoint ? "center" : "flex-start"}
        paddingRight={isMobileBreakpoint ? "230px" : "0px"}
        width="211px"
        src={`${window.gc.global.assets_url}/static/images/web-ui/valkyrae/exclusive_v2.svg`}
        filter="brightness(0) invert(1)"
        alt="Exclusive content badge"
        role="img"
      />
      <Flex
        pl={isMobileBreakpoint ? undefined : "30px"}
        alignItems={isMobileBreakpoint ? "center" : "flex-start"}
        flexDirection="column"
        gap={
          isMobileBreakpoint
            ? "24px"
            : ["8px", "8px", "8px", "8px", "8px", "16px"]
        }
        px={isMobileBreakpoint ? "24px" : undefined}
      >
        <Text
          as="h1"
          fontFamily="Bricolage Grotesque"
          textAlign={isMobileBreakpoint ? "center" : "left"}
          fontSize={["40px", "48px", "48px", "48px", "64px", "64px"]}
          fontWeight="800"
          lineHeight="100%"
          color="charcoal.charcoal"
        >
          Welcome to Valkyrae's world of comics
        </Text>
        <Text
          fontFamily="Roboto"
          textAlign={isMobileBreakpoint ? "center" : "left"}
          fontSize={["18px", "18px", "18px", "20px", "20px", "20px"]}
          fontWeight="500"
          lineHeight="120%"
          color="neutral.800"
          width="300px"
          maxWidth="100%"
        >
          Featuring <span style={{ fontStyle: "italic" }}>Apollyon</span>, from
          her very own Hihi Studios, coming soon.
        </Text>
        <Flex gap="18px" flexDirection="column" alignItems="center">
          <Button
            marginTop="12px"
            variant="primary"
            height="48px"
            gap="8px"
            borderRadius="20px"
            padding={isMobileBreakpoint ? "7px 16px" : "14px 32px"}
            onClick={handleCta2}
            aria-label="Watch video to learn more about Valkyrae's comics"
          >
            <PlayIcon boxSize="20px" aria-hidden="true" />
            <Text
              fontSize="16px"
              lineHeight="11px"
              letterSpacing=".75px"
              fontWeight="500"
            >
              Watch to learn more!
            </Text>
          </Button>
          {isUserGold ? null : (
            <Button
              variant="link"
              fontFamily="Roboto"
              fontSize="16px"
              fontWeight="500"
              lineHeight="100%"
              color="blaze.blaze"
              _hover={{ textDecoration: "underline" }}
              _focus={{
                outline: "2px solid",
                outlineColor: "blaze.blaze",
                outlineOffset: "2px",
              }}
              onClick={handleCta}
              aria-label="Subscribe to access Apollyon and exclusive content"
            >
              Subscribe now!
            </Button>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
}
